import { post } from '../http';

export const inviteFriend = (email, name) => post(`v2/FriendInvites`, { email, name });
